import { connect } from 'react-redux'
import filter from 'lodash/filter'
import map from 'lodash/map'
import get from 'lodash/get'
import { push } from 'react-router-redux'

import Calendar from '../../components/calendar/calendar'
import { loadWorkOrdersForPeriod } from '../../actions/work-orders'
import { loadAllLocationsForCalendar } from '../../actions/locations'
import { setCalendarIsLoading, setCalendarFilterDate, setCurrentView } from '../../actions/calendar-filters'

const mapStateToProps = (state) => {
  const {
    date,
    currentView = 'month',
    locationId,
    areaId,
    technicianId,
    serviceIds,
  } = state.calendarFilters

  if (!date) return { workOrders: [], currentDate: new Date() }
  const year = date.getFullYear(), month = date.getMonth()

  let workOrders = get(state.calendarFilters, `${year}.${month}.workOrders`, [])

  if (locationId) {
    workOrders = filter(workOrders, (wo) => {
      return wo.location.id == locationId
    })
  }

  if (areaId) {
    workOrders = filter(workOrders, (wo) => {
      return map(wo.areas, 'id').includes(areaId)
    })
  }

  if (technicianId) {
    workOrders = filter(workOrders, (wo) => {
      return map(wo.technicians, 'id').includes(technicianId)
    })
  }

  if (serviceIds && serviceIds.length > 0) {
    // current implementation checks if a work order contains all
    // of the services selected. To change the behaviour to check for "at least one"
    // match, switch every by some (s/every/some/) below
    workOrders = filter(workOrders, wo => serviceIds.every(serviceId => wo.services.includes(serviceId)))
  }
  
  return {
    workOrders,
    currentDate: date,
    currentView,
  }
}

const mapDispatchToProps = (dispatch) => {
  dispatch(loadAllLocationsForCalendar())

  return {
    setCurrentView (currentView) {
      dispatch(setCurrentView(currentView))
    },

    goToWorkOrder (id) {
      dispatch(push(`/work-orders/${id}/details`))
    },

    goToSummaryWorkOrder (id) {
      dispatch(push(`/summaries/${id}`))
    },

    createWorkOrderOnSlot (start, end) {
      dispatch(push({
        pathname: '/calendar/create-work-order',
        query: {
          start: start.toISOString(),
          end: end.toISOString()
        }
      }))
    },

    loadWorkOrdersForDate(date) {
      const y = date.getFullYear(), m = date.getMonth()
      const startDate = new Date(y, m, 0), endDate = new Date(y, m+1, 1)
      dispatch(setCalendarFilterDate(date))
        .then(() => dispatch(setCalendarIsLoading(y, m)))
        .then(() => dispatch(loadWorkOrdersForPeriod(y, m, startDate, endDate)))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Calendar)



// WEBPACK FOOTER //
// ./src/containers/calendar/calendar-container.js